// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"eO-z","carouselContainer":"fO-z"};